function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 3.29411L4.8535 5.94583C4.658 6.14172 4.342 6.14172 4.1465 5.94583C3.951 5.74995 3.951 5.43332 4.1465 5.23744L6.793 2.58571H5.5C5.2235 2.58571 5 2.36127 5 2.08473C5 1.80818 5.2235 1.58374 5.5 1.58374H7.5H8.5V4.58966C8.5 4.86621 8.2765 5.09065 8 5.09065C7.7235 5.09065 7.5 4.86621 7.5 4.58966V3.29411ZM4 2.08473C4 2.36127 3.7765 2.58571 3.5 2.58571H2.5V7.59558H7.5V6.59361C7.5 6.31707 7.7235 6.09262 8 6.09262C8.2765 6.09262 8.5 6.31707 8.5 6.59361V7.59558C8.5 8.14867 8.052 8.59756 7.5 8.59756H2.5C1.948 8.59756 1.5 8.14867 1.5 7.59558V2.58571C1.5 2.03212 1.948 1.58374 2.5 1.58374H3.5C3.7765 1.58374 4 1.80818 4 2.08473Z",
  fill: "#212B36"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 1,
  y: 1,
  width: 8,
  height: 8
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 3.29411L4.8535 5.94583C4.658 6.14172 4.342 6.14172 4.1465 5.94583C3.951 5.74995 3.951 5.43332 4.1465 5.23744L6.793 2.58571H5.5C5.2235 2.58571 5 2.36127 5 2.08473C5 1.80818 5.2235 1.58374 5.5 1.58374H7.5H8.5V4.58966C8.5 4.86621 8.2765 5.09065 8 5.09065C7.7235 5.09065 7.5 4.86621 7.5 4.58966V3.29411ZM4 2.08473C4 2.36127 3.7765 2.58571 3.5 2.58571H2.5V7.59558H7.5V6.59361C7.5 6.31707 7.7235 6.09262 8 6.09262C8.2765 6.09262 8.5 6.31707 8.5 6.59361V7.59558C8.5 8.14867 8.052 8.59756 7.5 8.59756H2.5C1.948 8.59756 1.5 8.14867 1.5 7.59558V2.58571C1.5 2.03212 1.948 1.58374 2.5 1.58374H3.5C3.7765 1.58374 4 1.80818 4 2.08473Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

function SvgButtonPreviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPreviewIcon);
export default __webpack_public_path__ + "static/media/button-preview-icon.f1029965.svg";
export { ForwardRef as ReactComponent };